// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__sCcPG","uploadMessage":"styles_uploadMessage__hb59y","text":"styles_text__wNL8O"};